/** Site-wide links and contact details (from the legacy About and FAQ pages). */
export const LINKS = {
  feedbackRainfallFlow:
    "https://forms.office.com/Pages/ResponsePage.aspx?id=PfKopOEaHEuZAuqhUwKBkLfF7RbFiCdKlqnmjECrBFxUMTBTVFpTSlcxM1VJSkM3NUdQQTdBSU5ENi4u",
  feedbackInfiltration:
    "https://forms.office.com/Pages/ResponsePage.aspx?id=PfKopOEaHEuZAuqhUwKBkLfF7RbFiCdKlqnmjECrBFxUNElCTFBLWlFPQUZGUTA0QTdFMkFXTDRTNi4u",
  apiDocs: "/docs/api.md",
  sourceCode: "https://github.com/SCCWRP/bmp-hydrology-calculator",
  sccwrp: "https://www.sccwrp.org",
  bmpDatabaseMonitoring: "https://bmpdatabase.org/monitoring",
  contactEmail: "stormwater@sccwrp.org",
};

/** Markdown served from the docs/ folder of the site bucket. */
export const DOCS = {
  about: "/docs/about.md",
  instructions: {
    rainfall: "/docs/instructions/rainfall.md",
    flow: "/docs/instructions/flow.md",
    infiltration: "/docs/instructions/infiltration.md",
  },
  methods: {
    rainfall: "/docs/methods/rainfall.md",
    flow: "/docs/methods/flow.md",
    infiltration: "/docs/methods/infiltration.md",
  },
} as const;

/** Demo data and templates (frontend/public/downloads), with the legacy download names. */
export const DOWNLOADS = {
  rainfall: [
    { label: "1-min demo data", href: "/downloads/demo_rainfall_1min_data.xlsx", filename: "demo_rainfall_1min_data.xlsx" },
    { label: "Time-of-tips demo data", href: "/downloads/demo_rainfall_timeoftips_data.xlsx", filename: "demo_rainfall_timeoftips_data.xlsx" },
    { label: "Rainfall template", href: "/downloads/rainfall_template.xlsx", filename: "rainfall_template.xlsx" },
  ],
  flow: [
    { label: "Flow demo data", href: "/downloads/demo_flowrate_data.xlsx", filename: "demo_flowrate_data.xlsx" },
    { label: "Flow template", href: "/downloads/flow_template.xlsx", filename: "flow_template.xlsx" },
  ],
  infiltration: [
    { label: "Infiltration demo data", href: "/downloads/demo_infiltration_data.xlsx", filename: "demo_infiltration_data.xlsx" },
    { label: "Infiltration template", href: "/downloads/infiltration_template.xlsx", filename: "template_infiltration.xlsx" },
  ],
};
